import Typography from '@/components/Typography';
import { TextStyles } from '@/constants';
import CloseSvgIcon from '@/public/images/icons/close_icon.svg';
import SyncSvgIcon from '@/public/images/icons/sync.svg';
import styled, { keyframes } from 'styled-components';

export const BannerMainText = styled(Typography).attrs({
  variant: TextStyles['Button'],
})(({ theme }) => ({
  textTransform: 'uppercase',
  textAlign: 'center',
  color: theme.colors.blue,
  marginLeft: theme.spacing[8],
  flex: 1,
}));

export const BannerSubText = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})(({ theme }) => ({
  textAlign: 'center',
  color: theme.colors.highEmphasisBlack,
}));

export const BannerHeader = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing[8],
  marginRight: theme.spacing[20],
  maxWidth: 270,
}));

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
`;

export const SyncIcon = styled(SyncSvgIcon).attrs({ width: 20, height: 20 })`
  animation-name: ${rotate};
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`;

export const ButtonCloseIcon = styled.button({
  display: 'flex',
  position: 'absolute',
  top: 8,
  right: 8,
  backgroundColor: 'transparent',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
});

export const CloseIcon = styled(CloseSvgIcon).attrs({ width: 20, height: 20 })(({ theme }) => ({
  path: {
    fill: theme.colors.highEmphasisBlack,
  },
}));

export const SyncInProgressContainer = styled.div(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: `${theme.spacing[14]} ${theme.spacing[16]}`,
  background: theme.colors.surface02,
  borderRadius: 4,
}));

export const SyncInProgressBannerWrapper = styled.div(({ theme }) => ({
  [`${theme.mediaBreakpointDown.md}`]: {
    marginTop: `${theme.spacing[16]}`,
  },
}));
